import { ErrorHandler, NgModule  , CUSTOM_ELEMENTS_SCHEMA, Injectable, Optional, Inject, APP_INITIALIZER} from '@angular/core';
import {
 MatTabsModule
} from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatRadioModule } from '@angular/material/radio';
import { FileUploadModule } from 'primeng/fileupload';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button'
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatPaginatorModule} from '@angular/material/paginator';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule, routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DropdownModule } from 'primeng/dropdown';
import { PrivacyNoticeComponent } from './Inside-Of-Application/privacy-notice/privacy-notice.component';
import { PreloaderComponent } from './Inside-Of-Application/preloader/preloader.component';
import { LoginComponent } from './Out-Of-Application/login/login.component';
import { LogoutComponent } from './Out-Of-Application/logout/logout.component';
import { PageNotFoundComponent } from './Out-Of-Application/page-not-found/page-not-found.component';
import { AlertComponent } from './Out-Of-Application/alert/alert.component';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientJsonpModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { DataService, UIBlockingStatus } from './CommonService/data.service';
import { AppTokenHandler, HTTPStatus, UserInfo } from './CommonService/app-token-handler';
import { AuthGuardService } from './CommonService/auth-guard.service';
import { RouterModule } from '@angular/router';
import { AppErrorHandler } from './CommonService/app-error-handler.service';
import { ProgressService } from './CommonService/progress.service';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { Interceptor } from './CommonService/Interceptor';
import { CommonModule } from '@angular/common';  
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './Inside-Of-Application/home/home.component';
import { GlobalVariables } from 'src/app/GlobalVariables';
import { CommonService } from './Shared/common.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CreateGTCRequisitionComponent } from './Inside-Of-Application/Requisition/create-gtcrequisition/create-gtcrequisition.component';
import { AllRequisitionViewComponent } from './Inside-Of-Application/Requisition/all-requisition-view/all-requisition-view.component';
import { MyRequistionComponent } from './Inside-Of-Application/Requisition/my-requistion/my-requistion.component';
import { AllApprovedRequisitionComponent } from './Inside-Of-Application/Requisition/all-approved-requisition/all-approved-requisition.component';
import { FileUploadComponent } from './Out-Of-Application/file-upload/file-upload.component';
import { MatDialogModule } from '@angular/material/dialog';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { RoleAssignmentComponent } from './Inside-Of-Application/role-assignment/role-assignment.component';
import {TableModule } from 'primeng/table';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Moment } from 'moment';
import * as moment from 'moment';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AddClauseComponent } from './Inside-Of-Application/add-clause/add-clause.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TQApprovalComponent } from './Inside-Of-Application/tqapproval/tqapproval.component';
import { SpecialApprovalComponent } from './Inside-Of-Application/special-approval/special-approval.component';
import { ReportsComponent } from './Inside-Of-Application/reports/reports.component';
import { PreLoaderComponent } from './Out-Of-Application/pre-loader/pre-loader.component';
import { AuditTrailComponent } from './Out-Of-Application/audit-trail/audit-trail.component';
import { ClauseAuditTrailComponent } from './Out-Of-Application/clause-audit-trail/clause-audit-trail.component';
import { AppFooterComponent } from './Shared/app-footer/app-footer.component';
import { CustomValidators } from './Shared/CustomValidators';
import { AzureADAuthService } from './CommonService/azure-adauth.service';
//import { ConfigService } from './CommonService/ConfigService';
import { OnlyDecimalDirective } from './Shared/Pipes/OnlyDecimalDirective';


export const MY_FORMATS = {
  parse: {
      dateInput: 'LL',
  },
  display: {
      dateInput: 'DD/MM/YYYY', monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Injectable()

export class MomentUtcDateAdapter extends MomentDateAdapter {

    constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
        super(dateLocale);
    }

     override createDate(year: number, month: number, date: number): Moment {
        // Moment.js will create an invalid date if any of the components are out of bounds, but we
        // explicitly check each case so we can throw more descriptive errors.
        if (month < 0 || month > 11) {
            throw Error(`Invalid month index "${month}". Month index has to be between 0 and 11.`);
        }

        if (date < 1) {
            throw Error(`Invalid date "${date}". Date has to be greater than 0.`);
        }

        let result = moment.utc({ year, month, date }).locale(this.locale);

        // If the result isn't valid, the date must have been out of bounds for this month.
        if (!result.isValid()) {
            throw Error(`Invalid date "${date}" for month with index "${month}".`);
        }

        return result;
    }
}
// export function initializeApp(config: ConfigService) {
//   return () => config.loadConfig();
// }
@NgModule({
  declarations: [
    AppComponent,
    PrivacyNoticeComponent,
    PreloaderComponent,
    LoginComponent,
    LogoutComponent,
    PageNotFoundComponent,
    AlertComponent,
    HomeComponent,
    CreateGTCRequisitionComponent,
    AllRequisitionViewComponent,
    MyRequistionComponent,
    AllApprovedRequisitionComponent,
    FileUploadComponent,
    RoleAssignmentComponent,
    AddClauseComponent,
    TQApprovalComponent,
    SpecialApprovalComponent,
    ReportsComponent,
    PreLoaderComponent,
    AuditTrailComponent,
    ClauseAuditTrailComponent,
    AppFooterComponent,
    OnlyDecimalDirective
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  imports: [
    BrowserModule,
    MatDialogModule,
    MatCheckboxModule,
    MatTooltipModule,
    CheckboxModule,
    MatTabsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    TableModule,
    MatTableModule,
    MatInputModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatButtonModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatCardModule,
    MatIconModule,
    MatDividerModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    ToggleButtonModule,
    DropdownModule,
    MatRadioModule,
    FileUploadModule,
    AutoCompleteModule,
    AppRoutingModule,
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  
  providers: [   DataService, AppTokenHandler, HTTPStatus,AuthGuardService,UIBlockingStatus,
    // ConfirmationService,
    AppErrorHandler, UserInfo,
    CommonService,GlobalVariables,
    CustomValidators,
    AzureADAuthService,
    ProgressService,
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initializeApp,
    //   deps: [ConfigService],
    //   multi: true
    // },
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor , multi : true},
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: MomentUtcDateAdapter },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    // provideHttpClient(withInterceptors([Interceptor])),
    // { provide: LocationStrategy, useClass: HashLocationStrategy }
  
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
